import { Injectable, OnInit } from '@angular/core';

//Providers-Services
import { CrudService } from '../crud.service';
import { EstadoService } from '../shared/estado.service';

// import Permisos
import { permiso } from '../../components/shared/permisos';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class MenuBoxService {

  // Bandera crear iniciativa
  public inicOn: boolean = true;

  // Box Menú Ordenes de Compa
  //agregar nueva opción verificar en funcion que esté activada la revisión del permiso para que aparezca la opción de crear nuevo menú
  BOXMENUOC: any = [
    { class: 'success', icon: 'share', title: 'Verificar', data: 0, path: 'ordenes', filter: '', desc: 'Registrar nueva solicitud', modal: 'true', modalpath: 'modalordenesnuevo' },
    { class: 'info', icon: 'info', title: 'Total', data: 0, path: 'ordenes', filter: '', desc: 'Total de OC registradas', estado: 'allx' },
    { class: 'deep-orange', icon: 'question', title: 'Validar', data: 0, path: 'ordenes', filter: 'Validar', desc: 'OC por validar', estado: 'none' },
    { class: 'success', icon: 'check', title: 'Validadas', data: 0, path: 'ordenes', filter: 'Validada', desc: 'OC Validadas', estado: 'Validada' },
    { class: 'danger', icon: 'trash', title: 'Anuladas', data: 0, path: 'ordenes', filter: 'Anulada', desc: 'OC anuladas', estado: 'Anulada' },
    { class: 'primary', icon: 'lock', title: 'Cerradas', data: 0, path: 'ordenes', filter: 'Cerrada', desc: 'OC cerradas', estado: 'Cerrada' }
  ];

  // Box Menú Proveedores
  BOXMENUPROVEEDORES: any = [
    { class: 'success', icon: 'plus', title: 'Nuevo', modal: 'true', data: '', path: 'proveedores', modalpath: 'modalprov', filter: '', permiso: '', desc: 'Registar nuevo proveedor' },
    { class: 'info', icon: 'info', title: 'Total', modal: 'false', data: 0, path: 'proveedores', filter: '', permiso: '', desc: 'Total de proveedores registrados', estado: 'allx' },
    { class: 'deep-orange', icon: 'question', title: 'Validar', modal: 'false', data: 0, path: 'proveedores', filter: 'Validar', permiso: '', desc: 'Proveedores por validar', estado: 'none' },
    { class: 'indigo', icon: 'check', title: 'Validado', modal: 'false', data: 0, path: 'proveedores', filter: 'Validado', permiso: '', desc: 'Proveedores validados', estado: 'Validado' }
  ];

  // Box Menú Documentos
  BOXMENUDOCUMENTOS: any = [
    //{ class: 'success', icon: 'share',  title: 'Verificar', data: 0, path: 'ordenes',  filter: '', desc: 'Registrar nueva solicitud', modal: 'true',modalpath: 'modalordenesnuevo' },
    //{ class: 'success', icon: 'share',  title: 'DTE', data: '', path: 'documentos',  filter: '', desc: 'Activar descarga facturas DTE', modal: 'true', modalpath: 'modalaccesodte' },
    //  { class: 'success', icon: 'plus', title: 'Nuevo', modal: 'true', data: '', path: 'gestautos', modalpath: 'modalgestautos', permiso: '', desc: 'Registrar nueva solicitud' },
    { class: 'success', icon: 'plus', title: 'Nuevo', modal: 'true', data: '', path: 'documentos', modalpath: 'modaldoc', filter: '', permiso: '', desc: 'Registar nuevo documento' },
    { class: 'info', icon: 'info', title: 'Total', modal: 'false', data: 0, path: 'documentos', filter: '', permiso: '', desc: 'Total de documentos registrados', estado: 'allx' },
    { class: 'deep-orange', icon: 'file', title: 'PreDocs', modal: 'false', data: 0, path: 'documentos', filter: 'PreDocumento', permiso: '', desc: 'PreDocumentos realizados', estado: 'PreDocumento' },
    { class: 'deep-magenta', icon: 'reply', title: 'Devueltos', modal: 'false', data: 0, path: 'documentos', filter: 'Devuelto', permiso: '', desc: 'Documentos devueltos', estado: 'Devuelto' },
    { class: 'success', icon: 'check', title: 'Aprobados', modal: 'false', data: 0, path: 'documentos', filter: 'Aprobado', permiso: '', desc: 'PreDocumentos probados', estado: 'Aprobado' },
    { class: 'warning', icon: 'question', title: 'Incompletos', modal: 'false', data: 0, path: 'documentos', filter: 'Incompleto', permiso: '', desc: 'documentos en incompletos', estado: 'Incompleto' },
    { class: 'indigo', icon: 'paper-plane', title: 'Despachados', modal: 'false', data: 0, path: 'documentos', filter: 'Despachado', permiso: '', desc: 'Documentos despachos', estado: 'Despachado' },
    { class: 'danger', icon: 'trash', title: 'Anulados', modal: 'false', data: 0, path: 'documentos', filter: 'Anulado', permiso: '', desc: 'Documentos rechazados', estado: 'Anulado' },
    { class: 'primary', icon: 'lock', title: 'Cerrados', modal: 'false', data: 0, path: 'documentos', filter: 'Cerrada', permiso: '', desc: 'Documentos cerrados', estado: 'Cerrado' },
    { class: 'secondary', icon: 'share', title: 'DTE', modal: 'true', data: '', filter: '', permiso: 'true', path: 'documentos', modalpath: 'modalaccesodte', desc: 'Activar descarga facturas DTE' },
    { class: 'success', icon: 'plus', title: 'Cargar Doc', modal: 'true', data: '', filter: '', permiso: 'true', path: 'documentos', modalpath: 'modalnuevodoc', desc: 'Cargar documentos manualmente' }
    //{ class: 'success', icon: 'share',  title: 'DTE', modal: 'false', data: '', filter: '', permiso: '', path: 'documentos', modalpath: 'modalaccesodte', desc: 'Activar descarga facturas DTE' }
  ];

    // Box Menú Documentos
  BOXMENUFACTURAS: any = [
    { class: 'info', icon: 'info', title: 'Total', modal: 'false', data: 0, path: 'facturas', filter: '', permiso: '', desc: 'Total de facturas registradas', estado: 'allx' },
    { class: 'deep-orange', icon: 'file-text-o', title: 'Facturas', modal: 'false', data: 0, path: 'facturas', filter: 'facturas', permiso: '', desc: 'Total Facturas', estado: 'facturas' },
    { class: 'deep-magenta', icon: 'file-text-o', title: 'Nota de crédito', modal: 'false', data: 0, path: 'facturas', filter: 'credito', permiso: '', desc: 'Total Notas de créditos', estado: 'credito' },
    { class: 'success', icon: 'file-text-o', title: 'Nota de débito', modal: 'false', data: 0, path: 'facturas', filter: 'debito', permiso: '', desc: 'Total Notas de débito', estado: 'debito' },
    { class: 'warning', icon: 'file-text-o', title: 'Boletas', modal: 'false', data: 0, path: 'facturas', filter: 'boletas', permiso: '', desc: 'Total Boletas', estado: 'boletas' },
    { class: 'indigo', icon: 'file-text-o', title: 'Invoice', modal: 'false', data: 0, path: 'facturas', filter: 'invoice', permiso: '', desc: 'Total Invoice', estado: 'invoice' },
  ];

  // Box Menú Solicitud de Pago
  BOXMENUSOLPAGO: any = [
    // { class: 'success', icon: 'plus', title: 'Nueva', modal: 'true', data: '', path: 'solpago', modalpath: 'modalsolpaginicio', filter: '', permiso: '', desc: 'Registrar nueva solicitud' },
    { class: 'success', icon: 'plus', title: 'Nueva', modal: 'true', data: '', path: 'solpago', modalpath: 'modalsolpagnueva', filter: '', permiso: '', desc: 'Registrar nueva solicitud' },
    { class: 'info', icon: 'info', title: 'Total', modal: 'false', data: 0, path: 'solpago', filter: '', permiso: '', desc: 'Solicitudes registradas desde el 28/03/2025', estado: 'allx' },
    { class: 'primary', icon: 'file-text', title: 'Creadas', modal: 'false', data: 0, path: 'solpago', filter: 'Creada', permiso: '', desc: 'Total de solicitudes creadas', estado: 'Creada' },
    { class: 'indigo', icon: 'paper-plane', title: 'Despachadas', modal: 'false', data: 0, path: 'solpago', filter: 'Despachada', permiso: '', desc: 'Solicitudes despachadas', estado: 'Despachada' },
    { class: 'warning', icon: 'inbox', title: 'Recibidas', modal: 'false', data: 0, path: 'solpago', filter: 'Recibida', permiso: '', desc: 'Solicitudes recibidas', estado: 'Recibida' },
    { class: 'success', icon: 'check', title: 'Autorizada', modal: 'false', data: 0, path: 'solpago', filter: 'Autorizada', permiso: '', desc: 'Solicitudes autorizadas', estado: 'Autorizada' },
    { class: 'deep-magenta', icon: 'reply', title: 'Devueltas', modal: 'false', data: 0, path: 'solpago', filter: 'Devuelta', permiso: '', desc: 'Solicitudes devueltas', estado: 'Devuelta' },
    { class: 'danger', icon: 'trash', title: 'Anulada', modal: 'false', data: 0, path: 'solpago', filter: 'Anulada', permiso: '', desc: 'Solicitudes anuladas', estado: 'Anulada' },
    { class: 'gray', icon: 'usd', title: 'Pagadas', modal: 'false', data: 0, path: 'solpago', filter: 'Pagada', permiso: '', desc: 'Solicitudes pagadas', estado: 'Pagada' },
    { class: 'primary', icon: 'lock', title: 'Cerradas', modal: 'false', data: 0, path: 'solpago', filter: 'Cerrada', permiso: '', desc: 'Solicitudes cerradas', estado: 'Cerrada' },
    { class: 'gray', icon: 'calendar', title: 'Historico', modal: 'false', path: 'solpago', filter: 'Historico', permiso: '', desc: 'Total de solicitudes registradas', estado: 'Historico' },
    { class: 'success', icon: 'plus', title: 'SOP Manual', modal: 'true', data: '', path: 'solpago', modalpath: 'modalsolpagmanual', filter: '', permiso: 'true', desc: 'Crear SOP manual' }
  ];

  // Box Menú Consolidado de Iniciativas
  BOXMENUCONSINIC: any = [
    { class: 'success', icon: 'plus', title: 'Nueva', modal: 'true', data: '', path: 'consolinic', modalpath: 'modalinicnueva', permiso: '', desc: 'Registrar nueva iniciativa' },
    { class: 'info', icon: 'info', title: 'Total', modal: 'false', data: 0, path: 'consolinic', filter: '', permiso: '', desc: 'Total de iniciativas registradas', estado: 'allx' },
    { class: 'deep-orange', icon: 'lightbulb-o', title: 'Nuevas', data: 0, path: 'consolinic', filter: 'Nueva', permiso: '', desc: 'Nuevas Iniciativas', estado: 'Nueva' },
    { class: 'primary', icon: 'calendar', title: 'Planificadas', data: 0, path: 'consolinic', filter: 'Planificada', permiso: '', desc: 'Iniciativas Planificadas', estado: 'Planificada' },
    //{ class: 'indigo', icon: 'question', title: 'No Planificadas', data: 0, path: 'consolinic', filter: 'No Planificadas', permiso: '', desc: 'Iniciativas No Planificadas', estado: 'No Planificadas' },
    //{ class: 'warning', icon: 'exclamation', title: 'Por Aprobar', data: 0, path: 'consolinic', filter: 'Por Aprobar', permiso: '', desc: 'Iniciativas Por Aprobar', estado: 'Por Aprobar' },
    { class: 'indigo', icon: 'edit', title: 'Por Corregir', data: 0, path: 'consolinic', filter: 'Por Corregir', permiso: '', desc: 'Iniciativas Por Corregir', estado: 'Por Corregir' },
    { class: 'warning', icon: 'exclamation', title: 'Jefe Compras', data: 0, path: 'consolinic', filter: 'Por Aprobar Jefe de Compras', permiso: '', desc: 'Iniciativas Por Aprobar Jefe de Compras', estado: 'Por Aprobar Jefe de Compras' },
    { class: 'warning', icon: 'exclamation', title: 'Jefe Finanzas', data: 0, path: 'consolinic', filter: 'Por Aprobar Jefe de Finanzas', permiso: '', desc: 'Iniciativas Por Aprobar Jefe de Finanzas', estado: 'Por Aprobar Jefe de Finanzas' },
    { class: 'warning', icon: 'exclamation', title: 'Jefe DAG', data: 0, path: 'consolinic', filter: 'Por Aprobar Jefe DAG', permiso: '', desc: 'Iniciativas Por Aprobar Jefe DAG', estado: 'Por Aprobar Jefe DAG' },
    { class: 'deep-magenta', icon: 'reply', title: 'Rechazado', data: 0, path: 'consolinic', filter: 'Rechazado', permiso: '', desc: 'Iniciativas Rechazadas', estado: 'Rechazado' },
    { class: 'success', icon: 'check', title: 'Aprobadas', data: 0, path: 'consolinic', filter: 'Aprobada', permiso: '', desc: 'Iniciativas Aprobadas', estado: 'Aprobada' },
    { class: 'danger', icon: 'trash', title: 'Eliminada', data: 0, path: 'consolinic', filter: 'Eliminada', permiso: '', desc: 'Iniciativas Eliminadas', estado: 'Eliminada' }
    // { class: 'primary', icon: 'lock', title: 'Cerradas', data: 0, path: '', filter: 'Cerrada', permiso: '', desc: '' }
  ];

  // Box Menú Solicitud de Compra
  BOXMENUSOLCOMP: any = [
    { class: 'success', icon: 'plus', title: 'Nueva', modal: 'true', data: 0, path: 'solcomp', modalpath: 'modalsolcompnueva', permiso: 'true', desc: 'Registrar nueva solicitud' },
    { class: 'info', icon: 'info', title: 'Total', modal: 'false', data: 0, path: 'solcomp', filter: '', permiso: '', desc: 'Total de solicitudes de compra', estado: 'allx' },
    { class: 'deep-orange', icon: 'lightbulb-o', title: 'Nuevas', data: 0, path: 'solcomp', filter: 'Nueva', permiso: '', desc: 'Nuevas Solicitudes de compra', estado: 'Nueva' },
    { class: 'primary', icon: 'dollar', title: 'Jefe Finanzas', data: 0, path: 'solcomp', filter: 'Jefe Finanzas', permiso: '', desc: 'Solicitudes de compra Jefe de Finanzas', estado: 'Jefe Finanzas' },
    { class: 'warning', icon: 'exclamation', title: 'Contraparte', data: 0, path: 'solcomp', filter: 'Contraparte', permiso: '', desc: 'Solicitudes de compra Contraparte PAC', estado: 'Contraparte' },
    { class: 'warning', icon: 'exclamation', title: 'Encargado PAC', data: 0, path: 'solcomp', filter: 'Encargado PAC', permiso: '', desc: 'Solicitudes de compra Encargado PAC', estado: 'Encargado PAC' },
    { class: 'warning', icon: 'exclamation', title: 'Jefe Unidad', data: 0, path: 'solcomp', filter: 'Jefe Unidad', permiso: '', desc: 'Solicitudes de compra Jefe de Unidad', estado: 'Jefe Unidad' }

    // quitar, es solo para pruebas

    //{ class: 'success', icon: 'print', title: 'imprsolcomp', modal: 'true', data: 0, path: 'imprsolcomp', modalpath: 'imprsolcomp', permiso: 'true', desc: 'Total de solicitudes registradas' }
  ];

  // Box Menú Gestión Autos
  BOXMENUGESTAUTOS: any = [
    { class: 'success', icon: 'plus', title: 'Nuevo', modal: 'true', data: '', path: 'gestautos', modalpath: 'modalgestautos', permiso: '', desc: 'Registrar nueva solicitud' },
    { class: 'info', icon: 'info', title: 'Total', data: 0, path: 'gestautos', filter: '', permiso: '', desc: 'Total de solicitudes registradas' },
    { class: 'deep-orange', icon: 'question', title: 'Aprobadas', data: 0, path: '', filter: 'Validar', permiso: '', desc: 'Solicitud por validar' },
    { class: 'danger', icon: 'times', title: 'Anulados', data: 0, path: '', filter: 'Anulada', permiso: '', desc: '' },
    { class: 'primary', icon: 'lock', title: 'Cerradas', data: 0, path: '', filter: 'Cerrada', permiso: '', desc: '' }
  ];

  // Box Menú Gestión Autos
  BOXMENUGESTBOLETOS: any = [
    { class: 'success', icon: 'plus', title: 'Nuevo', modal: 'true', data: '', path: 'gestboletos', modalpath: 'modalboletos', permiso: '', desc: '' },
    { class: 'info', icon: 'info', title: 'Total', data: 0, path: 'gestboletos', filter: '', permiso: '', desc: '' },
    { class: 'deep-orange', icon: 'question', title: 'Aprobadas', data: 0, path: '', filter: 'Validar', permiso: '', desc: '' },
    { class: 'danger', icon: 'times', title: 'Anulados', data: 0, path: '', filter: 'Anulada', permiso: '', desc: '' },
    { class: 'primary', icon: 'lock', title: 'Cerradas', data: 0, path: '', filter: 'Cerrada', permiso: '', desc: '' }
  ];

  // Box Menú Users
  BOXMENUUSERS: any = [
    { class: 'success', icon: 'plus', title: 'Nuevo', modal: 'true', data: '', path: 'user', modalpath: 'modaluser', filter: '', permiso: '', desc: 'Registrar nuevo usuario' },
    { class: 'info', icon: 'users', title: 'Total', modal: 'false', data: 0, path: 'user', filter: '', permiso: '', desc: 'Total de usuarios registrados', estado: 'allx' }
  ];

  // Box Menú Contraparte
  BOXMENUCONTRA: any = [
    { class: 'success', icon: 'plus', title: 'Nuevo', modal: 'true', data: '', path: 'contraparte', modalpath: 'modalcontra', filter: '', permiso: '', desc: 'Registar nuevo PreDocumento' },
    { class: 'info', icon: 'info', title: 'Total', modal: 'false', data: 0, path: 'contraparte', filter: '', permiso: '', desc: 'Total de documentos registrados', estado: 'allx' },
    { class: 'deep-orange', icon: 'file', title: 'PreDocs', modal: 'false', data: 0, path: 'contraparte', filter: 'PreDocumento', permiso: '', desc: 'PreDocumentos realizados', estado: 'PreDocumento' },
    { class: 'deep-magenta', icon: 'reply', title: 'Devueltos', modal: 'false', data: 0, path: 'contraparte', filter: 'Devuelto', permiso: '', desc: 'Documentos devueltos', estado: 'Devuelto' },
    { class: 'success', icon: 'check', title: 'Aprobados', modal: 'false', data: 0, path: 'contraparte', filter: 'Aprobado', permiso: '', desc: 'PreDocumentos probados', estado: 'Aprobado' },
    { class: 'warning', icon: 'question', title: 'Incompletos', modal: 'false', data: 0, path: 'contraparte', filter: 'Incompleto', permiso: '', desc: 'documentos en incompletos', estado: 'Incompleto' },
    { class: 'indigo', icon: 'paper-plane', title: 'Despachados', modal: 'false', data: 0, path: 'contraparte', filter: 'Despachado', permiso: '', desc: 'Documentos despachos', estado: 'Despachado' },
    { class: 'danger', icon: 'trash', title: 'Anulados', modal: 'false', data: 0, path: 'contraparte', filter: 'Anulado', permiso: '', desc: 'Documentos rechazados', estado: 'Anulado' },
    { class: 'primary', icon: 'lock', title: 'Cerrados', modal: 'false', data: 0, path: 'contraparte', filter: 'Cerrada', permiso: '', desc: 'Documentos cerrados', estado: 'Cerrado' }
  ];

  // Lista de permiso agrupados en localStorage
  public permisosUnicos;

  // Lista de permisos registrados
  public permisos;

  constructor(public _estadoService: EstadoService, public _crudService: CrudService) { }

  // Método encargado de asignar data a cada MenúBox
cargarEstado(type, tableNew, tableOldr, i?, filterUser?): Observable<any> {
  let array;

  const ObsEstado = new Observable((obs) => {
    this.permisos = permiso;

    // Asegurarse que permisosUnicos sea siempre un array
    this.permisosUnicos = JSON.parse(localStorage.getItem('permisosUnicos') || '[]');

    let cont = 1;

    this._estadoService.estado(tableNew, filterUser).subscribe(data => {
      // Caso especial para proveedor
      if (tableNew === 'prov' && data.Validar !== undefined) {
        data.none = Number(data.none) + Number(data.Validar);
      }

      const promesa = new Promise((resolve) => {
        switch (type) {
          case 'contra':
            this.BOXMENUCONTRA[0].permiso = (
              Array.isArray(this.permisosUnicos) &&
              this.permisosUnicos.includes(this.permisos.gContra) &&
              !this.permisosUnicos.includes(this.permisos.gAudt)
            ) ? 'true' : 'false';

            array = this.BOXMENUCONTRA;
            break;

          case 'oc':
            this.BOXMENUOC[0].permiso = (
              Array.isArray(this.permisosUnicos) &&
              this.permisosUnicos.includes(this.permisos.gPac) &&
              !this.permisosUnicos.includes(this.permisos.gAudt)
            ) ? 'true' : 'true'; // ¿Esto está bien? Siempre da 'true'
            array = this.BOXMENUOC;
            break;

          case 'prov':
            this.BOXMENUPROVEEDORES[0].permiso = (
              (this.permisosUnicos.includes(this.permisos.gFnnz) && !this.permisosUnicos.includes(this.permisos.gAudt)) ||
              this.permisosUnicos.includes(this.permisos.gSifac)
            ) ? 'true' : 'false';

            array = this.BOXMENUPROVEEDORES;
            break;

          case 'docu':
            this.BOXMENUDOCUMENTOS[0].permiso = (
              this.permisosUnicos.includes(this.permisos.gSifac) &&
              !this.permisosUnicos.includes(this.permisos.gAudt)
            ) ? 'true' : 'false';

            array = this.BOXMENUDOCUMENTOS;
            break;

          case 'facturas':
            this.BOXMENUFACTURAS[0].permiso = (
              this.permisosUnicos.includes(this.permisos.gSifac) &&
              !this.permisosUnicos.includes(this.permisos.gAudt)
            ) ? 'true' : 'false';

            array = this.BOXMENUFACTURAS;
            break;

          case 'sopa':
            this.BOXMENUSOLPAGO[0].permiso = (
              this.permisosUnicos.includes(this.permisos.gSifac) &&
              !this.permisosUnicos.includes(this.permisos.gAudt)
            ) ? 'true' : 'false';

            array = this.BOXMENUSOLPAGO;
            break;

          case 'inic':
            if (this.permisosUnicos.includes(this.permisos.gPac)) {
              const user = JSON.parse(localStorage.getItem('currentUser') || '{}');

              const rol = user?.role?.[0]?.role?.[0];
              if (rol === 'Encargado PAC' || rol === 'dvlp' || rol === 'stdagAdmin') {
                this.BOXMENUCONSINIC[0].permiso = 'true';
              } else {
                this._crudService.getOnOff().subscribe(
                  estado => {
                    this.BOXMENUCONSINIC[0].permiso = (estado.data['onOffInic'] === 'on') ? 'true' : 'false';
                  },
                  error => {
                    if (error.status === 400 || error.status === 403) {
                      this.BOXMENUCONSINIC[0].permiso = 'false';
                    }
                  }
                );
              }
            } else {
              this.BOXMENUCONSINIC[0].permiso = 'false';
            }

            array = this.BOXMENUCONSINIC;
            break;

          case 'paxx':
            this.BOXMENUSOLCOMP[0].permiso = (
              this.permisosUnicos.includes(this.permisos.gPac) &&
              !this.permisosUnicos.includes(this.permisos.gAudt)
            ) ? 'true' : 'false';

            array = this.BOXMENUSOLCOMP;
            break;

          case 'user':
            this.BOXMENUUSERS[0].permiso = (
              this.permisosUnicos.includes(this.permisos.dvlpRole) ||
              (this.permisosUnicos.includes(this.permisos.user) && !this.permisosUnicos.includes(this.permisos.gAudt))
            ) ? 'true' : 'false';

            array = this.BOXMENUUSERS;
            break;
        }

        resolve(array);
      });

      promesa.then((arrayFull) => {
        // Setear atributos en 0
        array.forEach(docu => docu.data = 0);

        for (const key in data) {
          array.forEach(element => {
            if (key === element.estado) {
              element.data = data[key];
            }
          });

          if (Object.keys(data).length === cont) {
            if (tableOldr !== 'false') {
              this._estadoService.estado(tableOldr, filterUser).subscribe(data => {
                array[i].data = data.allx;
                obs.next(array);
              });
            } else {
              obs.next(array);
            }
          }

          cont++;
        }
      });
    });
  });

  return ObsEstado;
}


}
